













import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import PathPicker from './PathPicker.vue';
import IslandBadge from './IslandBadge.vue';
import { PathViewModel } from '@/features/bots/models/designer';
import { Getter } from 'vuex-class';

@Component({
	components: {
		IslandBadge,
		PathPicker
	}
})
export default class LinkedPathsBox extends Vue {
	@Getter public linkedPaths!: PathViewModel[];
}
